<template>
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <h4 class="text-center">Basic mapping statistics</h4>
      </div>

      <div class="col-md-12"></div>
      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_a]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="genome_size"
              label="Genome size"
              width="160">
            </el-table-column>
            <el-table-column
              prop="total_reads"
              label="Total reads"
              width="160">
            </el-table-column>
            <el-table-column
              prop="pf_unique_reads"
              label="PF uniq reads"
              width="160">
            </el-table-column>
            <el-table-column
              prop="pct_pf_uq_reads"
              label="% PF uniq reads"
              width="160">
            </el-table-column>
            <el-table-column
              prop="pf_uq_reads_aligned"
              label="PF uniq reads aligned"
              width="200">
            </el-table-column>
            <el-table-column
              prop="pct_pf_uq_reads_aligned"
              label="% PF uniq reads aligned"
              width="200">
            </el-table-column>
          </el-table>
        </card>
      </div>
      <div class="col-md-12"></div>
    </div>

    <el-divider></el-divider>

    <div class="row">
      <div class="col-md-12">
        <h4 class="text-center"></h4>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_a]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="median_target_coverage"
              label="Median coverage"
              width="140">
            </el-table-column>
            <el-table-column
              prop="mean_target_coverage"
              label="Mean coverage"
              width="140">
            </el-table-column>
            <el-table-column
              prop="max_target_coverage"
              label="Max coverage"
              width="140">
            </el-table-column>
            <el-table-column
              prop="min_target_coverage"
              label="Min coverage"
              width="140">
            </el-table-column>
            <el-table-column
              prop="fold_80_base_penalty"
              label="Uniformity"
              width="140">
            </el-table-column>
            <el-table-column
              prop="at_dropout"
              label="AT dropout"
              width="180">
            </el-table-column>
            <el-table-column
              prop="gc_dropout"
              label="GC dropout"
              width="180">
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div>

      <el-divider></el-divider>

    <div class="row">
      <div class="col-md-12">
        <h4 class="text-center">Genes coverage</h4>
      </div>

      <div class="col-md-12"></div>
      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="qc_c"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="Gene"
              width="130">
            </el-table-column>
            <el-table-column
              prop="c_start"
              label="Start"
              width="90">
            </el-table-column>
            <el-table-column
              prop="c_end"
              label="Stop"
              width="90">
            </el-table-column>
            <el-table-column
              prop="length"
              label="Length"
              width="100">
            </el-table-column>
            <el-table-column
              prop="mean_coverage"
              label="Mean coverage"
              width="120">
            </el-table-column>
           <el-table-column
              prop="min_coverage"
              label="Min coverage"
              width="120">
            </el-table-column>
           <el-table-column
              prop="max_coverage"
              label="Max coverage"
              width="120">
            </el-table-column>
           <el-table-column
              prop="pct_0x"
              label="% 0X"
              width="100">
            </el-table-column>
           <el-table-column
              prop="read_count"
              label="Read counts"
              width="100">
            </el-table-column>           <el-table-column
              prop="gc"
              label="% GC"
              width="100">
            </el-table-column>
          </el-table>
        </card>
      </div>
      <div class="col-md-12"></div>
    </div>


    <!-- <div class="row">
      <div class="col-md-12">
        <h4 class="text-center">MAPPING STATISTICS</h4>
      </div>

      <div class="col-md-12 mr-auto ml-auto">
        <card>
          <el-table
            :data="[qc_b]"
            border
            :header-cell-style="tableHeaderStyle"
            style="width: 100%">
            <el-table-column
              prop="median_insert_size"
              label="Median insert"
              width="120">
            </el-table-column>
            <el-table-column
              prop="mean_mapping_quality"
              label="Mean mapping qual"
              width="150">
            </el-table-column>
            <el-table-column
              prop="gc_percentage"
              label="% GC"
              width="80">
            </el-table-column>
            <el-table-column
              prop="mapped_reads_with_insertion_percentage"
              label="% Insertions"
              width="100">
            </el-table-column>
            <el-table-column
              prop="mapped_reads_with_deletion_percentage"
              label="% Deletions"
             width="100">
            </el-table-column>
            <el-table-column
              prop="general_error_rate"
              label="% Error rate"
              width="100">
            </el-table-column>
            <el-table-column
              prop="acgt_a"
              label="A"
              width="100">
            </el-table-column>
            <el-table-column
              prop="acgt_c"
              label="C"
              width="100">
            </el-table-column>
            <el-table-column
              prop="acgt_t"
              label="T"
              width="100">
            </el-table-column>
            <el-table-column
              prop="acgt_g"
              label="G"
              width="100">
            </el-table-column>
            <el-table-column
              prop="acgt_n"
              label="N"
              width="100">
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div> -->

    <!-- <div class="row"> -->
      <!-- <div class="col-md-12">
        <h4 class="text-center">  </h4>
      </div>
          
      <div class="col-md-6 mr-auto ml-auto">
        <div class="card">
          <div class="card-header">
            XY 123
          </div>
          <div class="card-body mr-auto ml-auto">
            <slot name="title-content">
              <div class="row">
                <div class="col-sm-7">
                  <div class="numbers pull-left">
                    <slot name="title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="title-label"></slot>
                  </div>
                </div>
              </div>
            </slot>
            <slot name="subtitle"></slot>
            <la-polar :data="chart_on_target" :width="400">
              <la-pie label-prop="name" show-value prop="pv"></la-pie>
            </la-polar>

          </div>

          <div class="card-footer">
            <slot name="footer">
              <hr>
              <div class="row">
                <div class="col-sm-7">
                  <div class="footer-title">
                    <slot name="footer-title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="footer-right"></slot>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>


      </div>
        
      <div class="col-md-6 mr-auto ml-auto">
        <div class="card">
          <div class="card-header">
            XY 123
          </div>
          <div class="card-body  mr-auto ml-auto">
            <slot name="title-content">
              <div class="row">
                <div class="col-sm-7">
                  <div class="numbers pull-left">
                    <slot name="title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="title-label"></slot>
                  </div>
                </div>
              </div>
            </slot>
            <slot name="subtitle"></slot>
            <la-polar :data="chart_on_target" :width="400">
              <la-pie show-label label-prop="name" show-value prop="pv"></la-pie>
            </la-polar>

          </div>

          <div class="card-footer">
            <slot name="footer">
              <hr>
              <div class="row">
                <div class="col-sm-7">
                  <div class="footer-title">
                    <slot name="footer-title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="footer-right"></slot>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>


      </div>
                
    </div> -->

    <!-- <div class="col-md-10 mr-auto ml-auto">
      <div class="card">
        <div class="card-header">
          XY 123
        </div>
        <div class="card-body mr-auto ml-auto">
          <slot name="title-content">
            <div class="row">
              <div class="col-sm-7">
                <div class="numbers pull-left">
                  <slot name="title"></slot>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="pull-right">
                  <slot name="title-label"></slot>
                </div>
              </div>
            </div>
          </slot>
          <slot name="subtitle"></slot>
          <la-cartesian :data="chart_test">
            <la-line prop="pv"></la-line>
            <la-y-axis></la-y-axis>
            <la-x-axis prop="name"></la-x-axis>
            <la-tooltip></la-tooltip>
          </la-cartesian>
        </div>

        <div class="card-footer">
          <slot name="footer">
            <hr>
            <div class="row">
              <div class="col-sm-7">
                <div class="footer-title">
                  <slot name="footer-title"></slot>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="pull-right">
                  <slot name="footer-right"></slot>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>


    </div> -->
      

    <el-divider></el-divider>


    <div class="col-md-12 mr-auto ml-auto">
      <div class="col-md-12">
        <h4 class="text-center">Target coverage</h4>
      </div>
      <div class="card">
        <div class="card-body mr-auto ml-auto">
          <slot name="title-content">
            <div class="row">
              <div class="col-sm-7">
                <div class="numbers pull-left">
                  <slot name="title"></slot>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="pull-right">
                  <slot name="title-label"></slot>
                </div>
              </div>
            </div>
          </slot>
          <slot name="subtitle">Bases in target region [%]</slot>
          <la-cartesian narrow :data="chart_bar_a" :width="800">
            <la-bar prop="value"></la-bar>
            <la-x-axis :fontSize="13" prop="name"></la-x-axis>
            <la-y-axis :fontSize="13" :nbTicks="5" gridline prop="XXXXXX"></la-y-axis>
            <la-tooltip></la-tooltip>

          </la-cartesian>
          <div class="col-sm-12">
            <div class="pull-right">
              <slot name="title-label">Coverage</slot>
            </div>
          </div>

        </div>

        <div class="card-footer">
          <slot name="footer">
            <hr>
            <div class="row">
              <div class="col-sm-7">
                <div class="footer-title">
                  <slot name="footer-title"></slot>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="pull-right">
                  <slot name="footer-right"></slot>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
            
  </div>
</template>
<script>
  import moment from 'moment';
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue';
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import LineChart from 'src/components/UIComponents/Charts/LineChart';
  import BarChart from 'src/components/UIComponents/Charts/BarChart';
  import PieChart from 'src/components/UIComponents/Charts/PieChart';
  import {Badge, Card} from 'src/components/UIComponents';
  import TaskList from './Dashboard/Widgets/TaskList';

  import {Table, TableColumn, Divider } from 'element-ui';


  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };

  export default {
    name: 'exam_qc',
    props: {
      got_id_examination: {
        type: String,
        default: '0',
        description: ''
      },
    },
    components: {
      StatsCard,
      CircleChartCard,
      Badge,
      TaskList,
      Card,
      ChartCard,
      LineChart,
      BarChart,
      PieChart,
      Table,
      TableColumn,
      Divider,
    },

    computed: {
      ...mapState({
        token: state => state.token,
        qc_a: state => state.qc_a,
        qc_c: state => state.qc_c,
        id_examination: state => state.id_examination,
        chart_bar_a: state => state.chart_bar_a,
      }),
    },


    data () {
      return {
        mydata: [
          33,
          22,
        ],
        aa: 11,
        bb: 88,


        chart_test: [
          { name: 'Page A', pv: 2000 },
          { name: 'Page B', pv: 3000 },
          { name: 'Page C', pv: 1200 }
        ],       

        chart_on_target: [
          { name: 'Page A', pv: 2000 },
          { name: 'Page B', pv: 3000 },
          { name: 'Page C', pv: 1200 }
        ],       



        // statsCards: [
        //   {
        //     type: 'warning',
        //     icon: 'nc-icon nc-globe',
        //     title: 'Total Analyzed Samples',
        //     value: '3',
        //     footerText: 'Updated now',
        //     footerIcon: 'nc-icon nc-refresh-69'
        //   },
        //   {
        //     type: 'danger',
        //     icon: 'nc-icon nc-vector',
        //     title: 'Total workflows',
        //     value: '3',
        //     footerText: 'pre-paid',
        //     footerIcon: 'nc-icon nc-bell-55'
        //   },
        //   {
        //     type: 'info',
        //     icon: 'nc-icon nc-favourite-28',
        //     title: 'Your friends',
        //     value: '5',
        //     footerText: 'Updated now',
        //     footerIcon: 'nc-icon nc-refresh-69'
        //   },
        //   {
        //     type: 'info',
        //     icon: 'nc-icon nc-bulb-63',
        //     title: 'New variant status',
        //     value: '3',
        //     footerText: 'Updated now',
        //     footerIcon: 'nc-icon nc-refresh-69'
        //   }    
        // ],

        activeUsersChart: {
          data: {
            labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
            series: [542, 480, 430, 550, 530, 453, 380, 434, 568, 610]
          }
        },

        // emailsCampaignChart: {
        //   data: {
        //     labels: ["12pm", "3pm", "6pm", "9pm", "12am", "3am", "6am", "9am"],
        //     series: [40, 500, 650, 700, 1200, 1250, 1300, 1900]
        //   }
        // },

        // activeCountriesChart: {
        //   data: {
        //     labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October"],
        //     series: [80, 78, 86, 96, 83, 85, 76, 75, 88, 90]
        //   }
        // },

        // activityChart: {
        //   labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        //   datasets: [
        //     {
        //       label: "Data",
        //       borderColor: '#fcc468',
        //       fill: true,
        //       backgroundColor: '#fcc468',
        //       hoverBorderColor: '#fcc468',
        //       borderWidth: 8,
        //       data: [100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140, 130, 120, 130, 80, 100, 90, 120, 130],
        //     },
        //     {
        //       label: "Data",
        //       borderColor: '#4cbdd7',
        //       fill: true,
        //       backgroundColor: '#4cbdd7',
        //       hoverBorderColor: '#4cbdd7',
        //       borderWidth: 8,
        //       data: [80, 140, 50, 120, 50, 150, 60, 130, 50, 130, 150, 100, 110, 80, 140, 50, 140, 50, 110, 150],
        //     }
        //   ],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // stockChart: {
        //   labels: ["6pm", "9pm", "11pm", "2am", "4am", "6am", "8am"],
        //   datasets: [{
        //     label: "Active Users",
        //     borderColor: "#f17e5d",
        //     pointBackgroundColor: "#f17e5d",
        //     pointRadius: 3,
        //     pointHoverRadius: 3,
        //     lineTension: 0,
        //     fill: false,
        //     borderWidth: 3,
        //     data: [200, 250, 300, 350, 280, 330, 400]
        //   }],
        //   color: '#f17e5d',
        //   options: {
        //     tooltips: tooltipOptions,
        //     scales: {
        //       yAxes: [{

        //         ticks: {
        //           fontColor: "#9f9f9f",
        //           beginAtZero: false,
        //           maxTicksLimit: 3,
        //         },
        //         gridLines: {
        //           drawBorder: false,
        //           borderDash: [8, 5],
        //           zeroLineColor: "transparent",
        //           color: '#9f9f9f'
        //         }

        //       }],

        //       xAxes: [{
        //         barPercentage: 1.6,
        //         gridLines: {
        //           drawBorder: false,
        //           borderDash: [8, 5],
        //           color: '#9f9f9f',
        //           zeroLineColor: "transparent"
        //         },
        //         ticks: {
        //           padding: 20,
        //           fontColor: "#9f9f9f"
        //         }
        //       }]
        //     }
        //   }
        // },

        // viewsChart: {
        //   labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        //   datasets: [
        //     {
        //       label: "Data",
        //       borderColor: '#fcc468',
        //       fill: true,
        //       backgroundColor: '#fcc468',
        //       hoverBorderColor: '#fcc468',
        //       borderWidth: 5,
        //       data: [100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140, 130, 120, 130, 80, 100, 90, 120, 130],
        //     }
        //   ]
        // },


        // bioxsysChart: {
        //   labels: [1, 2],
        //   datasets: [{
        //     label: "Bioxsys",
        //     pointRadius: 0,
        //     pointHoverRadius: 0,
        //     backgroundColor: [
        //       'cyan',
        //       'yellow',
        //     ],
        //     borderWidth: 0,
        //     data: [this.qc_a["pct_selected_bases"], this.qc_a["pct_off_bait"]]
        //   }],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // concurrentChart: {
        //   labels: [1, 2],
        //   datasets: [{
        //     label: "Concurrent",
        //     pointRadius: 0,
        //     pointHoverRadius: 0,
        //     backgroundColor: [
        //       'green',
        //       'red',
        //     ],
        //     borderWidth: 0,
        //     data: [20, 80]
        //   }],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // emailChart: {
        //   labels: [1, 2, 3],
        //   datasets: [{
        //     label: "Emails",
        //     pointRadius: 0,
        //     pointHoverRadius: 0,
        //     backgroundColor: [
        //       '#e3e3e3',
        //       '#4acccd',
        //       '#fcc468'
        //     ],
        //     borderWidth: 0,
        //     data: [542, 480, 430]
        //   }],
        //   options: {
        //     tooltips: tooltipOptions
        //   }
        // },

        // chartHours: {
        //   data: {

        //     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
        //     datasets: [{
        //       borderColor: "#6bd098",
        //       backgroundColor: "#6bd098",
        //       pointRadius: 0,
        //       pointHoverRadius: 0,
        //       borderWidth: 3,
        //       data: [300, 310, 316, 322, 330, 326, 333, 345, 338, 354]
        //     },
        //       {
        //         borderColor: "#f17e5d",
        //         backgroundColor: "#f17e5d",
        //         pointRadius: 0,
        //         pointHoverRadius: 0,
        //         borderWidth: 3,
        //         data: [320, 340, 365, 360, 370, 385, 390, 384, 408, 420]
        //       },
        //       {
        //         borderColor: "#fcc468",
        //         backgroundColor: "#fcc468",
        //         pointRadius: 0,
        //         pointHoverRadius: 0,
        //         borderWidth: 3,
        //         data: [370, 394, 415, 409, 425, 445, 460, 450, 478, 484]
        //       }
        //     ]
        //   },
        //   options: {
        //     tooltips: tooltipOptions,
        //     scales: {
        //       yAxes: [{

        //         ticks: {
        //           fontColor: "#9f9f9f",
        //           beginAtZero: false,
        //           maxTicksLimit: 5,
        //           //padding: 20
        //         },
        //         gridLines: {
        //           drawBorder: false,
        //           zeroLineColor: "transparent",
        //           color: 'rgba(255,255,255,0.05)'
        //         }

        //       }],

        //       xAxes: [{
        //         barPercentage: 1.6,
        //         gridLines: {
        //           drawBorder: false,
        //           color: 'rgba(255,255,255,0.1)',
        //           zeroLineColor: "transparent",
        //           display: false,
        //         },
        //         ticks: {
        //           padding: 20,
        //           fontColor: "#9f9f9f"
        //         }
        //       }]
        //     }
        //   }
        // },


        // tableData: [{
        //   date: '2016-05-03',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }, {
        //   date: '2016-05-02',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }, {
        //   date: '2016-05-04',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }, {
        //   date: '2016-05-01',
        //   name: 'Tom',
        //   address: 'No. 189, Grove St, Los Angeles'
        // }],



      }





    },


    methods: {
      tableHeaderStyle ({row, column, rowIndex, columnIndex}) {
        return 'color:#000;font-weight:800;'
      },

      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },

    },






  }

</script>
<style scoped>
  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .top_padd {
    padding-top: 90px !important;
  }

.el-table {
    color: black !important;
}


el-table>.thead {
    color: red !important;
}

</style>
